var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "eagle-tap", class: _vm.tapClass },
    [
      _c("h3", {
        staticClass: "title",
        domProps: { innerHTML: _vm._s(_vm.tapContext.title) }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "fit-for" }, [
        _vm._v(_vm._s(_vm.tapContext.subTitle))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "price" }, [
        _c("span", { staticClass: "symble" }, [_vm._v("¥")]),
        _vm._v(" "),
        _c("span", { staticClass: "money" }, [
          _vm._v(_vm._s(_vm.price.toFixed(2)))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "origin-price" }, [
        _vm._v(_vm._s(_vm.tapContext.originPrice))
      ]),
      _vm._v(" "),
      _c(
        "e-button",
        {
          attrs: { round: "", type: _vm.btType },
          on: { click: _vm.buyTapClicked }
        },
        [_vm._v(_vm._s(_vm.tapContext.update))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "advantage" }, [
        _c("h3", { staticClass: "advantage-title" }, [
          _vm._v(_vm._s(_vm.tapContext.edition))
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "advantage-list" },
          [
            _c("li", [_vm._v(_vm._s(_vm.tapContext.saleText1))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.tapContext.saleText2))]),
            _vm._v(" "),
            _c("Tips", {
              attrs: {
                text: _vm.tapContext.saleText3,
                content: _vm.tapContext.saleTip,
                color: _vm.color
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("h3", { staticClass: "advantage-title" }, [
          _vm._v(_vm._s(_vm.extra.title))
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "advantage-list" },
          [
            _c("li", [_vm._v(_vm._s(_vm.extra.list[0]))]),
            _vm._v(" "),
            _vm.extra.noTip
              ? _c("li", [_vm._v(_vm._s(_vm.extra.list[1]))])
              : _c("Tips", {
                  attrs: {
                    text: _vm.extra.list[1],
                    content: _vm.getConstants("MARGINNOTE_LANDING_TIPS"),
                    color: _vm.color
                  }
                })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }